const ITEMS = [
  "AccijnsAdvies.be",
  "Strategisch Advies",
  "Compliance",
  "Licenties",
  "EMCS & NEW AC4",
  "Erkend Entrepothouder",
  "Fiscale Vertegenwoordiging",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-slate-200 bg-[#F8FAFC] py-6"
    >
      <div className="marquee-mask overflow-hidden">
        <div className="marquee-track">
          {loop.map((it, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display text-2xl font-bold tracking-tight text-[#0F172A] sm:text-3xl">
                {it}
              </span>
              <span className="mx-8 h-2 w-2 rounded-full bg-[#F59E0B]" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
